import Icon, { IconType } from "@components/ui/Icon";
import classNames from "classnames";
import React from "react";
import { FC } from "react";
import { twMerge } from "tailwind-merge";

export enum CategoryTypes {
  guides = "guides",
  tours = "tours",
  transportation = "transportation",
  "online-tours" = "online-tours",
  transfer = "transfer",
}

interface Props {
  category: CategoryTypes;
  selected?: boolean;
  actived: boolean;
  className?: string;
}

interface Categories {
  [key: string]: { icon: IconType; textDesktop: string; textMobile: string };
}

const Category: FC<Props> = ({
  category,
  selected = false,
  actived,
  className = "",
  ...props
}) => {
  const categories: Categories = {
    guides: {
      icon: "user",
      textDesktop: "Tour Guides",
      textMobile: "Guides",
    },
    tours: {
      icon: "flag",
      textDesktop: "Private Tours",
      textMobile: "Tours",
    },
    "online-tours": {
      icon: "globe",
      textDesktop: "Virtual Tours",
      textMobile: "Virtual",
    },
    transportation: {
      icon: "car",
      textDesktop: "Private Car Tours",
      textMobile: "Cars",
    },
    transfer: {
      icon: "transfer",
      textDesktop: "Airport Transfers",
      textMobile: "Transfer",
    },
  };

  const content = categories[category];

  const wrapperClassName = twMerge(
    classNames(
      "flex cursor-pointer items-center font-semibold flex-col md:flex-row border border-gray-200 shadow-md md:shadow-none rounded-lg md:rounded-full px-4 py-2 active:bg-gray-50",
      {
        "border px-4 py-2 bg-secondary text-white": selected,
        "opacity-60": !actived,
      }
    ),
    className
  );

  return (
    <div {...props} className={wrapperClassName}>
      <span>
        <Icon
          icon={content.icon}
          size="sm"
          className={`mr-0 md:mr-3 ${content.icon === "transfer" ? "w-4 h-4 xxs:w-8 xxs:h-8 -my-2 xxs:-my-1" : "w-4 h-4 xxs:w-6 xxs:h-6"} w-4 ${
            selected ? "text-white" : "text-secondary"
          }`}
        />
      </span>
      <span className="truncate md:w-full text-xxs xxs:text-xs xs:text-base md:text-base text-left">
        <span className="hidden md:flex">{content.textDesktop}</span>
        <span className="flex md:hidden">{content.textMobile}</span>
      </span>
    </div>
  );
};

export default Category;
